import { render, staticRenderFns } from "./LivestreamInteractionIndex.vue?vue&type=template&id=fe796ce0&"
import script from "./LivestreamInteractionIndex.vue?vue&type=script&lang=js&"
export * from "./LivestreamInteractionIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports